
import { FETCH_BREEDERS, ADD_SIGNATURE, FETCH_BREEDS_CATEGORY, FETCH_BREEDERS_VACCINE_DURATION,ADD_BREEDER, FETCH_BREEDER_BY_ID, FETCH_BREEDER_INFO, ADD_BREEDER_VACCINE, UPDATE_BREEDER, DELETE_BREEDER_VACCINE, CREATED_BREEDER_VACCINE, DELETE_BREEDER, FETCH_CURRENT_USER_SETTING, BREEDERS_SEARCH_VIA_BREEDTYPE, 
  FETCH_BREEDERS_APPLICATIONS, CREATE_BREEDER_APPLICATION, GET_BREEDER_APPLICATION,CHANGE_APPROVAL_STATUS_BREEDER_APPLICATION,
} from '../actions';

import { NotificationManager } from "react-notifications";
let initialState = {
  breederList: [],
  breederCategory: [],
  loading: false,
  breederListError: null,
  newSignatureError: null,
  breederCategoryError: null,
  newSignature: null,
  breederVaccineDuration: [],
  newBreeder: {},
  newBreederError: null,
  breedervaccineinfo: [],
  breederInfo:{},
  breederInfoError:null,  
  newVaccine:{},
  newVaccineError:null,
  updatedBreeder: {},
  deletedBreederVaccine: {},
  createdBreederVaccines: {},
  deletedBreeder: {},
  deletedBreederError: null,
  currentUser: null,
  currentUserError: null,
  searchedBreeders:[],
 // breederApplications:[],
  createdBreederApplications: {},
  selectedBreederApplication: {},
};

function breederReducer(state = initialState, action) {
  let breederList, newSignature, breederCategory,breederVaccineDuration, newBreeder, breedervaccineinfo, breederInfo, newVaccine, updatedBreeder, deletedBreederVaccine, deletedBreeder,  currentUser, currentUserError, searchedBreeders,
  breederApplications, createdBreederApplications, selectedBreederApplication,changedStatusApplication;

  switch (action.type) {
    case `${FETCH_BREEDERS}_PENDING`:
      return { ...state, breederListError: null, loading: true };

    case `${FETCH_BREEDERS}_FULFILLED`:
      breederList = action.payload.data;
      return { ...state, loading: false, breederList };

    case `${ADD_SIGNATURE}_PENDING`:
      return { ...state, newSignatureError: null, loading: true };

    case `${ADD_SIGNATURE}_FULFILLED`:
      newSignature = action.payload.data.signature_path;
      return { ...state, loading: false, newSignature };

    case `${FETCH_BREEDERS}_REJECTED`:
      return { ...state, loading: false, breederListError: `${action.payload.message}`, state: initialState };

    case `${ADD_SIGNATURE}_REJECTED`:
      return { loading: false, newSignatureError: `${action.payload.message}`, ...initialState };

    case `${FETCH_BREEDS_CATEGORY}_PENDING`:
      return { ...state, breederCategoryListError: null, loading: true };

    case `${FETCH_BREEDS_CATEGORY}_FULFILLED`:
      breederCategory = action.payload.data;
      return { ...state, loading: false, breederCategory };
    
    case `${FETCH_BREEDS_CATEGORY}_FULFILLED`:
      breederCategory = action.payload.data;
      return { ...state, loading: false, breederCategory };
  
    case `${FETCH_BREEDERS_VACCINE_DURATION}_PENDING`:
      return { ...state, breederVaccineError: null, loading: true };
    
    case `${FETCH_BREEDERS_VACCINE_DURATION}_FULFILLED`:
      breederVaccineDuration = action.payload.data;
      return { ...state, loading: false, breederVaccineDuration };
    
    case `${ADD_BREEDER}_PENDING`:
      return { ...state, newBreederError: null, loading: true };
    
    case `${ADD_BREEDER}_FULFILLED`:
      newBreeder = action.payload.data;
      return { ...state, loading: false, newBreeder };
    
    case `${ADD_BREEDER}_REJECTED`:
      return { ...state, loading: false, newBreederError: action.payload.response.data, };
    
    case `${FETCH_BREEDER_BY_ID}_FULFILLED`:
      let breedervaccine = action.payload.data.BreederVaccines;
      let vaccineinfo = [];
      if (breedervaccine) {
         breedervaccine.map(item => {
           if(item.Medication && item.Duration){
              let obj = {
                ...item,
                VaccineName: item.Medication.name ,
                DurationDays: item.Duration.days,
                DurationName: item.Duration.label,
                Type: item.Medication.type,
              }
              vaccineinfo.push(obj);
           }         
          })        
            breedervaccineinfo = vaccineinfo;
            return { ...state, loading: false, breedervaccineinfo };
          }       
    case `${FETCH_BREEDER_INFO}_PENDING`:
      return { ...state, breederInfoError: null, loading: true };
  
    case `${FETCH_BREEDER_INFO}_FULFILLED`:
           breederInfo = action.payload.data;          
      return { ...state, loading: false, breederInfo }; 
  
    case `${FETCH_BREEDER_INFO}_REJECTED`:
           breederInfo = action.payload.data;          
      return { ...state, loading: false, breederInfoError: action.payload.response.data, };
  
    case `${ADD_BREEDER_VACCINE}_PENDING`:
      return { ...state, newVaccineError: null, loading: true };
          
    case `${ADD_BREEDER_VACCINE}_FULFILLED`:
      newVaccine = action.payload.data;
      return { ...state, loading: false, newVaccine };
        
    case `${ADD_BREEDER_VACCINE}_REJECTED`:
       return { ...state, loading: false, newVaccineError: action.payload.response.data, };
  
    case `${UPDATE_BREEDER}_FULFILLED`:
      updatedBreeder = action.payload.data;
      return { ...state, loading: false, updatedBreeder };
  
    case `${UPDATE_BREEDER}_REJECTED`:
      return { ...state, loading: false, updatedBreederError: action.payload.response.data, }; 
  
    case `${DELETE_BREEDER_VACCINE}_FULFILLED`:
      deletedBreederVaccine = action.payload.data;
      return { ...state, loading: false, deletedBreederVaccine };
  
    case CREATED_BREEDER_VACCINE:
      return {...state, loading: false, createdBreederVaccines: action.payload, state: initialState };
      
    case `${DELETE_BREEDER}_FULFILLED`:     
      deletedBreeder = action.payload.data;
      return { ...state, loading: false, deletedBreeder };
  
    case `${DELETE_BREEDER}_REJECTED`:     
      return { ...state, loading: false, deletedBreederError: action.payload.response.data, }; 
  
    case `${DELETE_BREEDER}_PENDING`:
      return { ...state, deletedBreederError: null, loading: true };  
    
    case `${FETCH_CURRENT_USER_SETTING}_FULFILLED`:
      currentUser = action.payload.data;
      if (!currentUser) {
        NotificationManager.error(
          "You don't have an account associated with this pet shop"
        );
      }
      return { ...state, loading: false, currentUser };

    case `${FETCH_CURRENT_USER_SETTING}_REJECTED`:
      return {
        ...state,
        loading: false,
        currentUserError: `${action.payload.message}`
      }; 
    
   case `${ BREEDERS_SEARCH_VIA_BREEDTYPE }_FULFILLED`:
       searchedBreeders = action.payload.data;          
     return { ...state, loading: false, searchedBreeders };

   case `${FETCH_BREEDERS_APPLICATIONS}_FULFILLED`:     
     breederApplications = action.payload.data; 
     return { ...state, loading: false, breederApplications };
 
   case `${FETCH_BREEDERS_APPLICATIONS}_REJECTED`:     
     return { ...state, loading: false, breederApplicationsError: action.payload.response.data, }; 
 

  case `${CREATE_BREEDER_APPLICATION}_FULFILLED`:     
    createdBreederApplications = action.payload.data;
    return { ...state, loading: false, createdBreederApplications };
 
   case `${CREATE_BREEDER_APPLICATION}_REJECTED`:     
     return { ...state, loading: false, createdBreederApplicationsError: action.payload.response.data, }; 
 
   case `${CREATE_BREEDER_APPLICATION}_PENDING`:
     return { ...state, createdBreederApplicationsError: null, loading: true };  

  case `${GET_BREEDER_APPLICATION}_FULFILLED`:     
      selectedBreederApplication = action.payload.data;
     return { ...state, loading: false, selectedBreederApplication };
 
  case `${GET_BREEDER_APPLICATION}_REJECTED`:     
     return { ...state, loading: false, selectedBreederApplicationError: action.payload.response.data, }; 
 
  case `${GET_BREEDER_APPLICATION}_PENDING`:
     return { ...state, selectedBreederApplicationError: null, loading: true };

  case `${CHANGE_APPROVAL_STATUS_BREEDER_APPLICATION}_FULFILLED`:     
     changedStatusApplication = action.payload.data;
    return { ...state, loading: false, changedStatusApplication };

  case `${CHANGE_APPROVAL_STATUS_BREEDER_APPLICATION}_REJECTED`:     
    return { ...state, loading: false, changedStatusApplicationError: action.payload.response.data, }; 

  case `${CHANGE_APPROVAL_STATUS_BREEDER_APPLICATION}_PENDING`:
    return { ...state, changedStatusApplicationError: null, loading: true };
  
     
    default:
      return state;
  }
}

export default breederReducer;
